import { useEffect } from 'react'
import { t } from 'i18next'
import * as yup from 'yup'

export default function useYupLocale() {
  useEffect(() => {
    yup.setLocale({
      mixed: {
        required: () => t('validation.required'),
      },
      string: {
        email: () => t('validation.incorrectEmail'),
        max: ({ max }) => t('validation.max', { characters: max }),
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])
}
